import { Enums } from '../common/enums'
import { DataType } from '../../helpers/common-helper'
import { Utils } from '../util/utils'
import { DataProvider } from '../../helpers/data-provider'
import { Dictionary } from '../../helpers/dictionary'
import { CommonHelper } from '../../helpers/common-helper'

import { OpChartSeriesPoint } from './op-chart-series-point'
import { OpDescr } from '../core/op-descr'
import { OpDashboardControl } from './op-dashboard-control'
import { OpDashboardGroup } from './op-dashboard-group'
import { OpEnumObject } from './op-enum-object'
import { OpFile } from '../core/op-file'


export class OpGaugeRange {
    //Properties
    public minValue: number
    public maxValue: number
    public name: OpDescr
    public color: string
    //Properties end

    //NavigationProperties
    //NavigationProperties end

    constructor(opObj: any) {
        if (opObj) {
            this.minValue = opObj.MinValue
            this.maxValue = opObj.MaxValue
            if (opObj.Name)
                this.name = new OpDescr(opObj.Name)
            this.color = Utils.getHexColorFromSystemDrawingColor(opObj.Color)
        }
    }
}